import { FilterOption } from '#service/autocomplete-service/option';

class ShipmentStatusOptionService {
  getOptionsRaw() {
    return [
      { label: 'Not started', value: '100', id: '100' },
      { label: 'In progress', value: '200', id: '200' },
      { label: 'Stopped', value: '300', id: '300' },
      { label: 'Done', value: '400', id: '400' }
    ];
  }

  async fetchOptionsRaw(value, fetchOptions, ids) {
    const options = this.getOptionsRaw();

    if (ids) {
      const idsArray = ids.split(',');
      const filteredArray = options.filter(option => idsArray.includes(option.value));

      return filteredArray;
    }

    return options;
  }

  async getOptions(value, fetchOptions, ids) {
    const fetchedOptions = await this.fetchOptionsRaw(value, fetchOptions, ids);
    const transformedOptions = this.transformOptions(fetchedOptions);

    return transformedOptions;
  }

  transformOptions(options) {
    return options.map(option => {
      const label = `${option.label}`;
      return new FilterOption(option, label);
    });
  }
}

export default ShipmentStatusOptionService;
